import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface FishTypesFiltersState {
  nameSearch: string;
  scientificNameSearch: string;
  hasAbbreviationToggled: boolean;
  hasQuantityWeightToggled: boolean;
  hasSeasonalToggled: boolean;
}

const initialState: FishTypesFiltersState = {
  nameSearch: '',
  scientificNameSearch: '',
  hasAbbreviationToggled: false,
  hasQuantityWeightToggled: false,
  hasSeasonalToggled: false,
};

const fishTypesFiltersSlice = createSlice({
  name: 'fishTypesFilters',
  initialState,
  reducers: {
    setNameSearch(state, action: PayloadAction<string>) {
      state.nameSearch = action.payload;
    },
    setScientificNameSearch(state, action: PayloadAction<string>) {
      state.scientificNameSearch = action.payload;
    },
    setHasAbbreviationToggled(state, action: PayloadAction<boolean>) {
      state.hasAbbreviationToggled = action.payload;
    },
    setHasQuantityWeightToggled(state, action: PayloadAction<boolean>) {
      state.hasQuantityWeightToggled = action.payload;
    },
    setHasSeasonalToggled(state, action: PayloadAction<boolean>) {
      state.hasSeasonalToggled = action.payload;
    },
    resetFilters(state) {
      state.nameSearch = initialState.nameSearch;
      state.scientificNameSearch = initialState.scientificNameSearch;
      state.hasAbbreviationToggled = initialState.hasAbbreviationToggled;
      state.hasQuantityWeightToggled = initialState.hasQuantityWeightToggled;
      state.hasSeasonalToggled = initialState.hasSeasonalToggled;
    },
  },
});

export const {
  setNameSearch,
  setScientificNameSearch,
  setHasAbbreviationToggled,
  setHasQuantityWeightToggled,
  setHasSeasonalToggled,
} = fishTypesFiltersSlice.actions;

export const areFiltersAppliedSelector = (state: { fishTypesFilters: FishTypesFiltersState }) => {
  const { nameSearch, scientificNameSearch, hasAbbreviationToggled, hasQuantityWeightToggled, hasSeasonalToggled } =
    state.fishTypesFilters;

  return (
    !!nameSearch || !!scientificNameSearch || hasAbbreviationToggled || hasQuantityWeightToggled || hasSeasonalToggled
  );
};

export const activeFiltersCountSelector = (state: { fishTypesFilters: FishTypesFiltersState }) => {
  const { nameSearch, scientificNameSearch, hasAbbreviationToggled, hasQuantityWeightToggled, hasSeasonalToggled } =
    state.fishTypesFilters;

  let count = 0;
  if (nameSearch) count++;
  if (scientificNameSearch) count++;
  if (hasAbbreviationToggled) count++;
  if (hasQuantityWeightToggled) count++;
  if (hasSeasonalToggled) count++;

  return count;
};

export const fishTypesFiltersActions = fishTypesFiltersSlice.actions;

export const fishTypesFilters = fishTypesFiltersSlice.reducer;
